<template>
  <div class="submitKp">
    <section>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        class="demo-ruleForm"
      >
        <li class="redText">
          注意：※为必填项
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 购买方名称：
          </div>
          <el-form-item class="input_right" prop="gmfMc">
            <el-input placeholder="请输入购买方名称" v-model.trim="form.gmfMc" type="text"/>
          </el-form-item>
        </li>
        <div  style="margin-bottom: 10px">
          <p class="redText" style="font-size: 10px">
            注意：个人开具请填写身份证号码
          </p>
        </div>
        <li class="flex_input">
          <div class="lable_left">
            纳税人识别号：
          </div>
          <el-form-item class="input_right" prop="gmfSh">
            <el-input placeholder="请输入纳税人识别号" v-model.trim="form.gmfSh" type="text"/>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 地址及电话：
          </div>
          <el-form-item class="input_right" prop="gmfDz">
            <el-input placeholder="请输入地址及电话" v-model="form.gmfDz" type="text"/>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            开户行及账号：
          </div>
          <el-form-item class="input_right" >
            <el-input placeholder="请输入开户行及账号" v-model.trim="form.gmfYh" type="text"/>
          </el-form-item>
        </li>

        <li class="flex_input">
          <div class="lable_left">
            推送方式：
          </div>
          <el-form-item class="input_right" prop="pushMode">
            <dict-select dict-code="tsfs" :clearable="false" :is-constants="true" v-model="form.pushMode"/>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText" v-if="form.pushMode==1||form.pushMode==2">※</span> 手机号：
          </div>
          <el-form-item class="input_right" prop="buyerPhone">
            <el-input placeholder="请输入手机号" v-model.trim="form.buyerPhone" />
          </el-form-item>
        </li>
        <li class="flex_input" v-if="captchaValidate">
          <div class="lable_left">
            <span v-if="form.pushMode==1||form.pushMode==2" class="redText">※</span>
            验证码：
          </div>
          <el-form-item class="input_right" prop="captcha">
            <el-input placeholder="验证码" style="width: 60%;" v-model.trim="form.captcha" type="text"/>
            <button :disabled="disabled" type='button' @click.stop="getYzm" class="yzmBtn" style="width: 38%;">{{msg}}</button>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText" v-if="form.pushMode==2||form.pushMode==0">※</span> 邮箱：
          </div>
          <el-form-item class="input_right" prop="email">
            <el-input placeholder="请输入邮箱" v-model.trim="form.email" />
          </el-form-item>
        </li>
        <li>
          <span class="greyText">备注 </span> <span class="redText"> 注意：描述上限为200字</span>
        </li>
        <el-input placeholder="备注" type="textarea" clearable :autosize="{ minRows: 6, maxRows: 6 }"
                  v-model.trim="form.bz" maxlength="200" show-word-limit/>
        <!--        <li >-->
        <!--          <span class="redText" v-if="form.gmfMc&&form.gmfMc!=this.oldName" style="margin-right: 5px;">※ </span> 证明材料：<span class="buleText"-->
        <!--        </li>-->
        <!--        <div  style="margin-bottom: 10px">-->
        <!--          <p class="redText" style="font-size: 10px">-->
        <!--            1.与户主系亲属关系需上传户口本、结婚证等证明材料-->
        <!--          </p>-->
        <!--          <p class="redText" style="font-size: 10px">-->
        <!--            2.与户主租户关系需租房合同原件及双方身份证复印件-->
        <!--          </p>-->
        <!--        </div>-->
        <!--        <div class="file">-->
        <!--          <input-->
        <!--            type="file"-->
        <!--            accept="image/*"-->
        <!--            name="uploader-input"-->
        <!--            class="uploader-file"-->
        <!--            @change="getXc"-->
        <!--          />证明材料-->
        <!--        </div>-->
        <!--        <div v-for="(item,ind) in imgXcList" class="imgDiv">-->
        <!--          <b @click="deleteXc(ind)" class="el-icon-error error_icon"></b>-->
        <!--          <img class="imgItemRead avatar" :src="item" alt="">-->
        <!--        </div>-->
      </el-form>
    </section>
    <footer>
      <el-button class="btn_bind" @click="kpBtn" type="primary" size="mini" style="width: 100%">
        确认开票
      </el-button>
    </footer>
  </div>
</template>

<script>
  import {getCaptcha, getUser, saveInvoic} from "@/api";
  import {isCnNewID, validatePhone} from "@/utils";
  export default {
    data() {
      return {
        form: {
          pushMode: 1
        },
        rules: {
          gmfMc: [{ required: true, message: '必填', trigger: 'blur' }],
          gmfDz: [{ required: true, message: '必填', trigger: 'blur' }],
          pushMode: [{ required: true, message: '必填', trigger: 'blur' }],
          buyerPhone: [
            {
              max: 11,min:11,message: '请输入11位有效手机号',trigger:'blur'
            },
            { validator: validatePhone, trigger: 'blur' }
          ],
          gmfSh: [
            {
              max: 18,min:6,message: '请输入6-18位纳税人识别号',trigger:'blur'
            }
          ],
          sfzh: [
            { required: true, message: '必填', trigger: 'blur' },
            {validator: isCnNewID,trigger: "blur"}
          ],
        },
        oldName: '',
        imgXcList: [],
        fileList: [],
        maxtime: 60, //一个小时，按秒计算，自己调整!
        timer: null,
        msg: '获取验证码',
        disabled: false,
        captchaValidate: true
      }
    },
    mounted() {
      this.getUserInfo()
      this.captchaValidate = JSON.parse(sessionStorage.getItem('roles'))&&JSON.parse(sessionStorage.getItem('roles')).captchaValidate

    },
    methods: {
      getUserInfo() {
        getUser({
          code: this.$route.query.code,
        }).then((res) => {
          this.$set(this.form,'gmfDz',res.data.address)
          this.oldName = res.data.name
        });
      },
      getXc(e) {
        let file = e.target.files[0]
        this.fileList.push(file);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {    //成功读取文件
          this.imgXcList.push(e.target.result)
        };
        this.xczpFlag = false
      },
      deleteXc(ind) {
        this.imgXcList.splice(ind, 1);
        this.fileList.splice(ind, 1)
        this.xczpFlag = true
      },
      getYzm() {
        var reg_tel = /^(1)\d{10}$/;
        if(!reg_tel.test(this.form.buyerPhone)) {
          this.$toast('请输入正确的手机号码')
          return
        }
        let params = {
          sysType: 0,
          phone: this.form.buyerPhone,
        }
        getCaptcha(params).then(res=>{
          if(res.code=='0000') {
            this.maxtime = 60
            this.disabled = true
            this.timer = setInterval(() => {
              this.CountDown()
            }, 1000)
          }
        })
      },
      CountDown() {
        if (this.maxtime > 0) {
          let seconds = this.maxtime;
          this.msg = +seconds + "s" + '后获取';
          --this.maxtime;
        } else {
          clearInterval(this.timer);
          this.msg = '获取验证码'
          this.disabled = false
        }
      },
      kpBtn() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.form.issh = false
            this.form.czbh = this.$route.query.czbh
            if((this.form.pushMode==1||this.form.pushMode==2)&&!this.form.buyerPhone) {
              this.$toast("请输入手机号");
              return false;
            }
            if((this.form.pushMode==2||this.form.pushMode==0)&&!this.form.email) {
              this.$toast("请输入邮箱");
              return false;
            }
            // 用户姓名一致不需要审核，有备注需要审核，没有备注不需要审核
            // 用户姓名与开票不一致需要上传附件进行审核
            // if(this.oldName==this.form.gmfMc) {
            //   if(this.form.bz) {
            //     this.form.issh = true
            //   }
            // } else {
            //   this.form.issh = true
            //   if(this.fileList.length==0) {
            //     this.$toast("请上传证明材料");
            //     return false;
            //   }
            // }
            this.form.customerId = this.$route.query.userId
            var formdata = new FormData();
            for (let k in this.form) {
              formdata.append(k, this.form[k]);
            }
            // this.fileList.map(file => {
            //   formdata.append("files", file);
            // })
            saveInvoic(formdata).then(res=>{
              // this.$toast('成功')
              this.$router.go(-1)
            })
          }
        })
      }
    }
  }
</script>

<style>
  .submitKp{
    padding: 3%;
    min-height: 90%;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 90%;
  }
  section{
    flex: 1;
    overflow-y: auto;
    padding-bottom: 20px;;
  }
  footer{

  }
  .redText {
    color: red;
  }

  .lable_left {
    width: 105px;
    color: black;
  }

  .flex_input {
    display: flex;
    line-height: 40px;
  }

  .submitKp li {
    line-height: 40px;
    display: flex;
    border-bottom: 1px solid #F7F6F7;
  }
  .yzmBtn{
    border: 1px solid #C2E7B0;
    border-radius: 3px;
    line-height: 26px;
    background: #F0F9EB;
    color: #67C23A;
    font-size: 12px;
    /*background: #000;*/
  }
  .li_flex {
    justify-content: space-between;
  }

  .lable_right {
    color: #949393;
  }

  .greyText {
    color: #8c939d;
    margin-right: 10px;
  }

  .input_right {
    flex: 1;
    color: black;
  }

  .submitKp  .el-input__inner {
    padding: 0 !important;
  }

  .submitKp .input_right input, .input_right textarea {
    border: none;
    outline: none;
    float: 1;
    margin-top: 5px;
  }

  .submitKp .el-form-item {
    margin-bottom: 0 !important;
  }

  .uploader-file {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .uploader-file:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: 178px;
    display: block;
    margin-top: 25px;
  }

  .file {
    width: 90%;
    height: 30px;
    position: relative;
    display: inline-block;
    background: #FBFDFF;
    border: 1px #C0CCDA dashed;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1E88C7;
    text-decoration: none;
    text-indent: 0;
    text-align: center;
    line-height: 30px;
  }

  .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }

  .file:hover {
    background: #FBFDFF;
    border-color: #AADFFD;
    color: #004974;
    text-decoration: none;
  }

  .imgDiv {
    position: relative;
  }

  .error_icon {
    position: absolute;
    font-size: 25px;
    right: 0px;
    top: 0px;
    z-index: 999999;
    color: #f00;
  }

</style>



// WEBPACK FOOTER //
// src/view/ywbl/dzfp/SubmitKp.vue